import React, { useState } from "react";
import { useNeuroState } from "@ignitesales/neuro-application";

const useActionOnSubmit = () => {

  const { productCart } = useNeuroState();

  const openCreditCardLink = () => {
    const creditCardProductsIds = ['2680', '2682'];
    const hasAnyCreditCard = creditCardProductsIds.some(id => productCart.has(id));
    if (hasAnyCreditCard) {
      window.open('https://transact.commercebank.com/sfdc/servlet/SmartForm.html?formCode=cbcommericalonboard', '_blank');  
    }
  }

  return {
    openCreditCardLink,
  }
}

export default useActionOnSubmit;